import { render, staticRenderFns } from "./OrdersV2.vue?vue&type=template&id=535e8d58&"
import script from "./OrdersV2.vue?vue&type=script&lang=js&"
export * from "./OrdersV2.vue?vue&type=script&lang=js&"
import style0 from "./OrdersV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports